import { render, staticRenderFns } from "./AffiliatesStep.vue?vue&type=template&id=ab3bf66a"
import script from "./AffiliatesStep.vue?vue&type=script&lang=js"
export * from "./AffiliatesStep.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesStep.vue?vue&type=style&index=0&id=ab3bf66a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports